import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const JDCallback = () => {
  const nav = useNavigate();

  useEffect(() => {
    const run = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const code  = params.get('code');
        const state = params.get('state');
        if (!code || !state) throw new Error('Missing code/state');

        // 1️⃣ Hit backend callback
        await axios.post(
          `${process.env.REACT_APP_ORIGO_BASE_URL}oauth-jd/callback`,
          { code, state }
        );

        // Tokens already saved in Login.jsx (via /authorize)
        // So just redirect user to choose-data
        nav('/choose-data');
      } catch (e) {
        console.error('JD callback failed', e);
        alert('John Deere connection failed – please try again.');
        nav('/home');
      }
    };

    run();
  }, [nav]);

  return (
    <div className="flex items-center justify-center h-screen text-lg text-gray-600">
      Connecting to John Deere…
    </div>
  );
};

export default JDCallback;
